export default "__VITE_ASSET__BNpF5QXj__"